import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  position: relative;

  .content {
    position: relative;

    .title {
      text-align: center;
      font-size: 36px;
    }

    .story-content {
      margin-top: 30px;

      .swiper-button-custom {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        padding: 10px;
        cursor: pointer;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background: #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: center;

        polyline {
          color: black;
        }

        &.swiper-button-custom-prev {
          left: -74px;
          img {
            transform: rotate(180deg);
          }
        }
        &.swiper-button-custom-next {
          right: -74px;
        }
      }

      .swiper-slide {
        padding: 2px 0 15px 0;
      }

      .story-item {
        border-radius: 20px;
        overflow: hidden;
        background: ${theme.white};
        box-shadow: 0 10px 15px 0 rgba(168, 150, 120, 0.16);

        .image-story {
          img {
            width: 100%;
            aspect-ratio: 1801 / 1201;
          }
        }

        .info-block {
          padding: 10px 22px;
          h4 {
            line-height: 27px;
          }
          .detail {
            margin: 15px 0;
            color: ${theme.mediumGray};
            height: 66px;
          }
          .read-more {
            float: right;
            margin-bottom: 20px;
            color: ${theme.primaryRed};
          }
        }
      }
    }

    .story-content-mobile {
      display: none;
    }

    .button-block {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      button {
        span {
          font-size: 32px;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .content {
      .story-content {
        padding-top: 20px;
        .swiper {
          padding-bottom: 0;
        }
        .swiper-button-custom {
          &.swiper-button-custom-prev {
            left: -60px;
          }
          &.swiper-button-custom-next {
            right: -60px;
          }
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .content {
      border-radius: 0;
      background-color: transparent;
      .title {
        font-size: 20px;
      }
      .story-content {
        display: none;
      }
      .story-content-mobile {
        display: block;
        margin-top: 25px;
        .story-item {
          border-radius: 20px;
          overflow: hidden;
          background: ${theme.white};
          box-shadow: 0 10px 15px 0 rgba(168, 150, 120, 0.16);
          margin-bottom: 23px;

          .image-story {
            img {
              width: 100%;
              aspect-ratio: 292 / 200;
            }
          }

          .info-block {
            padding: 10px 22px;
            h4 {
              line-height: 27px;
            }
            .detail {
              margin: 15px 0;
              color: ${theme.mediumGray};
              height: 66px;
            }
          }

          .read-more-block {
            display: flex;
            background: #f8f9fa;
            align-items: center;
            justify-content: center;
            padding-top: 10px;
            padding-bottom: 18px;
            height: 100%;

            .read-more {
              font-size: 16px;
            }
          }
        }
      }
      .button-block {
        margin-top: 30px;
        button {
          span {
            font-size: 16px;
          }
        }
      }
    }
  }
`
